module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "calc"
    }
  }, [_c('bc-navbar'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pages_maincontent"
    }
  }, [_c('h2', {
    staticClass: "page_title"
  }, [_vm._v("PAYMENT CALCULATOR")]), _vm._v(" "), _c('div', {
    staticClass: "page_single layout_fullwidth_padding"
  }, [_c('div', {
    staticClass: "contactform"
  }, [_c('div', {
    staticClass: "form_row"
  }, [_c('label', [_vm._v("Vehicle Price ($)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.vehiclePrice),
      expression: "payment.vehiclePrice"
    }],
    staticClass: "form_input custom-text-size",
    attrs: {
      "type": "number",
      "name": "price",
      "value": "",
      "placeholder": "0"
    },
    domProps: {
      "value": (_vm.payment.vehiclePrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payment, "vehiclePrice", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_row"
  }, [_c('label', [_vm._v("Down Payment ($)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.downPrice),
      expression: "payment.downPrice"
    }],
    staticClass: "form_input custom-text-size",
    attrs: {
      "type": "number",
      "name": "payment",
      "value": "",
      "placeholder": "0"
    },
    domProps: {
      "value": (_vm.payment.downPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payment, "downPrice", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_row"
  }, [_c('label', [_vm._v("Term (Month)")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.months),
      expression: "payment.months"
    }],
    staticClass: "form_select custom-text-size",
    attrs: {
      "name": "term"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.payment, "months", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "24"
    }
  }, [_vm._v("24")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "36"
    }
  }, [_vm._v("36")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "48"
    }
  }, [_vm._v("48")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "60"
    }
  }, [_vm._v("60")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "72"
    }
  }, [_vm._v("72")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "84"
    }
  }, [_vm._v("84")])])]), _vm._v(" "), _c('div', {
    staticClass: "form_row"
  }, [_c('label', [_vm._v("Interest Rate")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.interestRate),
      expression: "payment.interestRate"
    }],
    staticClass: "form_input custom-text-size",
    attrs: {
      "type": "number",
      "name": "rate",
      "value": "",
      "placeholder": "0.0%"
    },
    domProps: {
      "value": (_vm.payment.interestRate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payment, "interestRate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_row"
  }, [_c('label', [_vm._v("Monthly Payment:")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("$")]), _vm._v(_vm._s(_vm.payment.mounthlyPayment))])]), _vm._v(" "), _c('div', {
    staticClass: "form_row"
  }, [_c('label', [_vm._v("Total Interest to Pay:")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("$")]), _vm._v(_vm._s(_vm.payment.totalInterest))])]), _vm._v(" "), _c('div', {
    staticClass: "form_row"
  }, [_c('label', [_vm._v("Total Amount:")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("$")]), _vm._v(_vm._s(_vm.payment.totalAmount))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isError),
      expression: "isError"
    }],
    staticClass: "form_row error"
  }, [_c('label', [_vm._v("Down Payment must be less then Vehicle Price")])]), _vm._v(" "), _c('input', {
    staticClass: "form_submit",
    style: (_vm.borderStyle),
    attrs: {
      "type": "button",
      "value": "CALCULATE"
    },
    on: {
      "click": _vm.calculate
    }
  })])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-330c1684", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-330c1684"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/calc.vue
// module id = 810
// module chunks = 0